import React from "react";
import { useUtilitiesContext } from "../../../contexts/UtilitiesContext";
import { useListUserAssignmentsQuery } from "../api/List";

export default function useGetUserAssignmentsHook() {
    const { showNotification } = useUtilitiesContext();

    const {
        data: userAssignmentsFromList = [],
        isError: isUserAssignmentListError,
        error: userAssignmentListError,
        isFetching: isUserAssignmentListFetching,
        refetch: refetchUserAssignmentList,
    } = useListUserAssignmentsQuery();

    React.useEffect(() => {
        if (isUserAssignmentListError && userAssignmentListError) {
            showNotification({
                type: "error",
                title: "Error",
                message: userAssignmentListError.message,
            });
        }
    }, [isUserAssignmentListError, userAssignmentListError, showNotification]);

    return {
        userAssignments: userAssignmentsFromList,
        isUserAssignmentFetching: isUserAssignmentListFetching,
        refetchUserAssignment: refetchUserAssignmentList,
    };
}
